import ContratTemplateActive from '@/generated/controls/contratTemplate/ContratTemplateActive.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: ContratTemplateActive
})
